const RESP_SOURCE = '__response_source';
const CACHE_STORAGE = 'cache';

function matchMethod(method) {
  return method === 'GET' || method === 'get';
}

function getRequestMatcher(method, url, headers, cacheConfig) {
  for (var i = 0; i < cacheConfig.matchers.length; i++) {
    if (matchMethod(method) && cacheConfig.matchers[i].urlMatches(url)) {
      return {
        ttl: cacheConfig.matchers[i].ttl
          ? cacheConfig.matchers[i].ttl
          : cacheConfig.default.ttl,
      };
    }
  }
  return null;
}

function buildCacheKeyFrom(request) {
  return `ram-cache-api-${request.headers['selected-language']}-${request.method}-${request.url}`;
}

function ttlNotExpired(cachedEntry) {
  var now = new Date().getTime();
  return now <= cachedEntry.timestamp + cachedEntry.ttl;
}

function getCachedValue(cacheKey, cacheConfig) {
  var cachedEntry = null;
  try {
    var rawstr = cacheConfig.storage.getItem(cacheKey);
    if (rawstr) {
      cachedEntry = JSON.parse(rawstr);
    }
  } catch (e) {
    console.error(e);
  }
  if (cachedEntry && ttlNotExpired(cachedEntry)) {
    return cachedEntry.data;
  }
  cacheConfig.storage.deleteItem(cacheKey);
  return null;
}

function setCachedValue(cacheKey, value, ttl, cacheConfig) {
  value.config.headers[RESP_SOURCE] = CACHE_STORAGE;
  const cachedEntry = {
    ttl: ttl,
    timestamp: new Date().getTime(),
    data: value,
  };
  try {
    cacheConfig.storage.setItem(cacheKey, JSON.stringify(cachedEntry));
  } catch (error) {
    console.error(error);
  }
}

function isCacheable(request, cacheConfig) {
  return getRequestMatcher(
    request.method,
    request.url,
    request.headers,
    cacheConfig,
  );
}

function isResponseSuccessful(response) {
  return true;
}

export function handleRequestCaching(request, cacheConfig) {
  console.log(' -> ' + request.method + '...');
  if (isCacheable(request, cacheConfig)) {
    const cacheKey = buildCacheKeyFrom(request);
    const response = getCachedValue(cacheKey, cacheConfig);
    if (response) {
      request.adapter = () => {
        return Promise.resolve(response);
      };
    }
  }
  return request;
}

export function handleResponseCaching(response, cacheConfig) {
  if (response.config.headers[RESP_SOURCE] === CACHE_STORAGE) {
    return response;
  }
  const matcher = isCacheable(response.config, cacheConfig);

  if (matcher && isResponseSuccessful(response)) {
    const cacheKey = buildCacheKeyFrom(response.config);
    setCachedValue(cacheKey, response, matcher.ttl, cacheConfig);
  }
  return response;
}
